import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
interface SharedCTAProps {
  selectedPlan: 'PRO' | 'Elite';
}
export function SharedCTA({
  selectedPlan
}: SharedCTAProps) {
  const url = selectedPlan === 'PRO' ? 'https://checkout.mundodigitalarg.com/cart/48251765620977:1' : 'https://checkout.mundodigitalarg.com/cart/48251770437873:1';
  return <div className="mt-6 md:mt-8 max-w-2xl mx-auto w-full flex flex-col items-center" data-id="element-188">
      <p className="text-[13px] md:text-sm font-bold text-slate-500 mb-2.5 md:mb-3 text-center uppercase tracking-wide" data-id="element-189">
        Elegiste:{' '}
        <span className="text-[#0a1f44]" data-id="element-190">
          Megapack Infantojuvenil {selectedPlan}
        </span>
      </p>

      <motion.a href={url} animate={{
      scale: [1, 1.02, 1]
    }} transition={{
      repeat: Infinity,
      duration: 3,
      ease: 'easeInOut'
    }} className="w-full bg-orange-600 hover:bg-orange-500 text-white font-black text-[15px] md:text-lg py-3.5 md:py-4 px-8 rounded-xl shadow-[0_0_20px_rgba(234,88,12,0.4)] transition-colors min-h-[52px] flex items-center justify-center text-center tracking-wide" data-id="element-191">
        💥 QUIERO MI MEGAPACK AHORA
      </motion.a>

      <div className="flex flex-wrap justify-center items-center gap-x-3 md:gap-x-4 gap-y-1.5 md:gap-y-2 mt-3 md:mt-4 text-[11px] md:text-xs font-semibold text-slate-500" data-id="element-192">
        <div className="flex items-center gap-1" data-id="element-193">
          <Lock className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-194" /> Pago seguro
        </div>
        <span className="hidden sm:inline text-slate-300" data-id="element-195">·</span>
        <div className="flex items-center gap-1" data-id="element-196">
          <Zap className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-197" /> Acceso en 5 min
        </div>
        <span className="hidden sm:inline text-slate-300" data-id="element-198">·</span>
        <div className="flex items-center gap-1" data-id="element-199">
          <ShieldCheck className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-200" /> Garantía 7 días
        </div>
        <span className="hidden sm:inline text-slate-300" data-id="element-201">·</span>
        <div className="flex items-center gap-1" data-id="element-202">
          <CreditCard className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-203" /> Mercado Pago
        </div>
      </div>
    </div>;
}